/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Services_Svc_Agents_Point_2Inputs */

const en_services_svc_agents_point_2 = /** @type {(inputs: Services_Svc_Agents_Point_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Budgets per run and per agent, with fallbacks`)
};

const lv_services_svc_agents_point_2 = /** @type {(inputs: Services_Svc_Agents_Point_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Budžets katrai palaišanai un aģentam, ar rezerves ceļiem`)
};

/**
* | output |
* | --- |
* | "Budgets per run and per agent, with fallbacks" |
*
* @param {Services_Svc_Agents_Point_2Inputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const services_svc_agents_point_2 = /** @type {((inputs?: Services_Svc_Agents_Point_2Inputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Services_Svc_Agents_Point_2Inputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_services_svc_agents_point_2(inputs)
	return en_services_svc_agents_point_2(inputs)
});